import { render, staticRenderFns } from "./clock-elapsed-time.vue?vue&type=template&id=317a7c31"
import script from "./clock-elapsed-time.vue?vue&type=script&lang=js"
export * from "./clock-elapsed-time.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports